// extracted by mini-css-extract-plugin
export default {"pageContainer":"page_pageContainer__wdmvs","imgWrapper":"page_imgWrapper__87qQh","contentWrapper":"page_contentWrapper__JQgPE"};